import { Field } from '@smartsoftware/reflex-core';
import { DexResourceModel } from '../abstracts/dexResource.model';

export class ClientMatterLayout extends DexResourceModel {

    @Field(String)
	public clientMatterLayoutInternalName: string = "";

    @Field(String)
	public clientMatterLayoutDisplayName: string = "";

    @Field(String)
    public clientMatterLayoutDescription: string = "";

    constructor(data?: any) {
        super();
        this.mapData(data);
    }

}
